export enum AssetAmountType {
  QUOTEASSET = 'quoteAssetAmount',
  BASEASSET = 'baseAssetAmount',
}
export enum AssetAmountNewType {
  FROMASSET = 'fromAssetAmount',
  TOASSET = 'toAssetAmount',
}
export const DEFAULT_AMOUNT = '';
